import { render, staticRenderFns } from "./apparatusData.vue?vue&type=template&id=a8b2a10c&scoped=true"
import script from "./apparatusData.vue?vue&type=script&lang=js"
export * from "./apparatusData.vue?vue&type=script&lang=js"
import style1 from "./apparatusData.vue?vue&type=style&index=1&id=a8b2a10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b2a10c",
  null
  
)

export default component.exports